import dayjs from "dayjs";
import React, { useState } from "react";
import PayHistorySection from "./PayBoard/PayHistorySection";
import DashBoardDateFilter from "./DashBoardDateFilter";
import { DashBoardDateFilterContainer, DashBoardSection } from "./UserBoard";

export default function PayBoard() {
  const [filter, setFilter] = useState({
    startDate: dayjs().add(-7, "day")?.format("YYYY-MM-DD") ?? "",
    endDate: dayjs().add(-1, "day")?.format("YYYY-MM-DD") ?? "",
    isAccum: false,
  });

  return (
    <DashBoardSection>
      <DashBoardDateFilterContainer>
        <DashBoardDateFilter
          setFilter={setFilter}
          filter={filter}
          isAfter={{ value: 2, unit: "week" }}
        />
      </DashBoardDateFilterContainer>

      {/* 거래 내역 */}
      <PayHistorySection filter={filter} setFilter={setFilter} />
    </DashBoardSection>
  );
}
